import UrlService from "../services/UrlService";
import DataParserHelper from "../utilities/DataParserHelper";

class UrlApi {
    getSuperUserLinks () {
        return new Promise((resolve, reject) => {
            UrlService.getSuperUserLinks()
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    }

    getApplicationLinks (showLoginPageUrls = false) {
        return new Promise((resolve, reject) => {
            UrlService.getApplicationLinks(showLoginPageUrls)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    getAvailableApplications (returnUrl) {
        return new Promise((resolve, reject) => {
            UrlService.getAvailableApplications(returnUrl)
                .then(result => resolve(DataParserHelper.getAvailableApplicationsFromRaw(result.data)))
                .catch(err => reject(err));
        });
    }
}

export default new UrlApi();
